import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PlusCircle } from 'lucide-react';
import { v4 as uuidv4 } from 'uuid';

// タスク追加フォームコンポーネント
const AddTaskForm = ({ onAddTask, onCancel }) => {
  const [title, setTitle] = useState('');
  const [items, setItems] = useState([
    { id: uuidv4(), text: '', dueDate: '', testDate: '', testScore: '' }
  ]);

  const handleAddItem = () => {
    setItems([...items, { id: uuidv4(), text: '', dueDate: '', testDate: '', testScore: '' }]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // バリデーション
    if (!title.trim() || items.some(item => !item.text.trim())) {
      alert('タイトルとすべてのチェック項目を入力してください。');
      return;
    }
    // チェック項目をオブジェクト形式に変換
    const itemsObject = items.reduce((acc, item, index) => {
      acc[item.id] = { ...item, order: index };
      return acc;
    }, {});
    onAddTask({ title, items: itemsObject });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 bg-yellow-50 rounded-lg shadow">
      <div className="flex flex-col gap-4">
        <div>
          <label htmlFor="task-title" className="font-medium text-purple-700">課題タイトル</label>
          <input
            id="task-title" // 一意のIDを追加
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className="w-full p-2 border border-purple-300 rounded mb-1 focus:outline-none focus:ring-2 focus:ring-purple-300"
            placeholder="例: 週末の数学課題"
            aria-label="課題タイトル入力"
          />
        </div>

        <div>
          <label className="font-medium text-purple-700">チェック項目</label>
          {items.map((item, index) => (
            <div key={item.id} className="flex flex-col gap-1 mb-3">
              <label htmlFor={`add-text-${item.id}`} className="sr-only">チェック項目 {index + 1}</label>
              <textarea
                id={`add-text-${item.id}`} // 一意のIDを追加
                value={item.text}
                onChange={(e) => {
                  const newItems = [...items];
                  newItems[index].text = e.target.value;
                  setItems(newItems);
                }}
                placeholder="例: 数学の問題を解く"
                className="p-2 border border-purple-300 rounded mb-1 focus:outline-none focus:ring-2 focus:ring-purple-300"
                rows={2}
                required
                aria-label={`チェック項目 ${index + 1} 入力`}
              />
            </div>
          ))}
        </div>

        {/* 項目の追加ボタン */}
        <div className="flex justify-start mt-4">
          <button
            type="button"
            onClick={handleAddItem}
            className="text-purple-500 hover:text-purple-600 flex items-center gap-1"
            aria-label="項目を追加ボタン"
          >
            <PlusCircle size={20} />
            項目を追加
          </button>
        </div>

        {/* 保存とキャンセルボタン */}
        <div className="flex justify-between mt-6">
          <button
            type="submit"
            className="bg-purple-300 text-purple-800 px-5 py-2 rounded hover:bg-purple-400"
            aria-label="課題保存ボタン"
          >
            保存
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="bg-purple-100 text-purple-700 px-5 py-2 rounded hover:bg-purple-200"
            aria-label="課題編集キャンセルボタン"
          >
            キャンセル
          </button>
        </div>
      </div>
    </form>
  );
};

AddTaskForm.propTypes = {
  onAddTask: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default AddTaskForm; 